import { render } from "./InnovationLabsPage.vue?vue&type=template&id=216fc020&scoped=true"
import script from "./InnovationLabsPage.vue?vue&type=script&lang=js"
export * from "./InnovationLabsPage.vue?vue&type=script&lang=js"

import "./InnovationLabsPage.vue?vue&type=style&index=0&id=216fc020&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-216fc020"]])

export default __exports__